import uploadConfirm from './uploadConfirm.vue'

export default {
  install(Vue, options = {}) {
    // 创建构造函数
    const UploadConfirm = Vue.extend(uploadConfirm)

    let instance
    let currentMsg

    window.addEventListener('popstate', () => {
      if (instance) {
        instance.warnDialog = false
        instance = null
        currentMsg = null
      }
    })

    const uploadConfirmFunc = (options = {}) => {
      if (!instance) {
        // 创建实例
        instance = new UploadConfirm({
          el: document.createElement('div')
        })
        document.body.appendChild(instance.$el)
      }

      // 合并参数与实例
      Object.assign(instance, options)
      Vue.nextTick(() => {
        instance.warnDialog = true
        // instance.total = options.total
      })
      UploadConfirm.prototype.callback = defaultCallback

      return new Promise((resolve, reject) => {
        currentMsg = {
          resolve,
          reject
        }
      })
    }

    function defaultCallback(action) {
      currentMsg.resolve()
    }

    // 将方法扩展到Vue的原型和实例上
    Vue.prototype.$uploadConfirm = Vue.uploadConfirm = uploadConfirmFunc
  }
}
